import { useQuery } from 'react-query'
import { AddressProps, UserAddressFormData } from '../../types/user'
import axios, { AxiosPromise } from 'axios'
import defaultOptions from '../../api/defaultoption'

export async function getAddressList(): Promise<AddressProps[]> {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_CLIENTES}clientes/enderecos`,
    {
      headers: defaultOptions.headers
    }
  )

  return data
}

export async function createNewAddress(address: AddressProps) {
  const response = await axios.post(
    `${process.env.REACT_APP_API_CLIENTES}clientes/enderecos`,
    address,
    {
      headers: defaultOptions.headers
    }
  )

  return response.data
}

export async function editAddressById(address: UserAddressFormData) {
  const response = await axios.put(
    `${process.env.REACT_APP_API_CLIENTES}clientes/enderecos/${address.id}`,
    address,
    {
      headers: defaultOptions.headers
    }
  )

  return response
}

export async function deleteAddress(id: string): Promise<AxiosPromise> {
  const response = await axios.delete(
    `${process.env.REACT_APP_API_ENDPOINT}clientes/clientes/enderecos/${id}`,
    {
      headers: defaultOptions.headers
    }
  )

  return response
}

export function useAddresses() {
  return useQuery('enderecos', getAddressList, {
    staleTime: 1000 * 60 // 1 minuto
  })
}
